/**
* Ads Manager
*
* Enables ad code to wait:
* - till initAds is called
*/

class AdsManager {
	constructor() {
		this._fullImplementationLoaded = true;
		this.queue = { push: this._onReady.bind(this) };
		this._adInitCalled = false;

		// Grab things from the placeholder
		this._callbacks = window.stshared_ads_manager.queue || [];
		if (stshared_ads_manager._adInitCalled) {
			this.initAds();
		}
    // getTargeting implementation lives in wp-content/plugins/smartertravel-shared/includes/ads/includes/freestar.php
    // it needs to live there because it is needed when the `freestar` object is initialized.
    this.getTargeting = window.stshared_ads_manager.getTargeting;
	}

	initAds() {
		this._adInitCalled = true;
    if (this._callbacks) {
			this._callbacks.forEach(f => this._onReady(f));
			delete this._callbacks;
		}
	}

	_isReady() {
		return this._adInitCalled;
	}

	/**
	 * Add an on ready event listener.
	 *
	 * @param {function} callbackFunc Event handler.
	 * @returns {void}
	 */
	 _onReady(callbackFunc) {
		if (this._isReady()) {
			if (window.freestar) {
				if (callbackFunc.placementName) {
					freestar.config.enabled_slots.push(callbackFunc);
				} else {
					freestar.queue.push(callbackFunc);
				}
			} else {
				// freestar is turned off
			}
		} else {
			this._callbacks.push(callbackFunc)
		}
	}
}

if (!window.stshared_ads_manager._fullImplementationLoaded) {
	window.stshared_ads_manager = new AdsManager();
}
